import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { QueryParams, QueryParamsForSelection, QueryResult } from 'src/app/modules/core/store/models/query.model';
import { FailedInvites, User } from './user.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';
@Injectable({ providedIn: 'root' })
export class UserApiService {
  constructor(private http: HttpService) {}

  getUsers(organizationUId: string, params: QueryParams): Observable<QueryResult<User>> {
    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles?${queryString}`;

    return this.http.get<QueryResult<User>>(url);
  }

  getUsersForSelection(organizationUId: string, params: QueryParamsForSelection): Observable<QueryResult<User>> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/for-selection`;
    return this.http.post<QueryResult<User>>(url, params);
  }

  inviteUsers(organizationUId: string, users: Partial<User>[]): Observable<FailedInvites[]> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/actions/invite-users`;
    return this.http.post(url, { users });
  }

  reinviteUser(organizationUId: string, user: User): Observable<void> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${user.uId}/actions/reinvite-user`;
    return this.http.post(url, user);
  }

  updateUser(organizationUId: string, user: User): Observable<User> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${user.uId}`;
    return this.http.put(url, user);
  }

  deleteUser(organizationUId: string, userUId: string): Observable<void> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${userUId}`;
    return this.http.delete(url);
  }

  deleteSelectedUsers(organizationUId: string, userUIds: string[]): Observable<number> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/bulk`;
    return this.http.post(url, userUIds);
  }

  searchUsers(organizationUId: string, params: QueryParams): Observable<QueryResult<User>> {
    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/search?${queryString}`;

    return this.http.get<QueryResult<User>>(url, params);
  }

  getTotalUserCount(organizationUId: string): Observable<number> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/total-user-count`;
    return this.http.get(url);
  }
}
